<template>
	<div>
		<!-- nav-checkout -->
		<div class="config-header bg-grey-b">
			<div class="user-config-opt">
				<ul class="list-none m-b-0 saveBuild">
					<template v-if="!POS_MODE">
						<li>
							<a
								data-toggle="modal"
								class="share-bld"
								@click="shareBuild('#share-overlay')"
							>SHARE</a>
						</li>
						<li class="m-x">
							<a data-toggle="modal" class="save-bld" @click="saveBuild()">SAVE</a>
						</li>
					</template>
				</ul>
				<div v-show="!isCheckoutOverlayOpen" class="option-row">
					<ul class="list-none m-b-0 checkout-affirm">
						<li>
							<affirm
								v-if="buildPrice && !POS_MODE && countryCode != 'CA'"
								:price="buildPrice"
								class="affirm-wrapper affirm-step-4"
							/>
							<paybright
								v-if="buildPrice && !POS_MODE && countryCode == 'CA'"
								:price="buildPrice"
								class="affirm-wrapper paybright-wrapper affirm-step-4"
							/>
							<a
								class="checkout-btn btn btn-purple inline"
								@click.prevent="gotoStep5('top')"
							>
								REVIEW &amp; CHECKOUT
							</a>
							<promo-sales-timed>
								<template v-slot:originalContent>
									<h2 class="pc-price inline text-white">${{ buildPrice | priceFormat }}</h2>
									<span class="currency-code">USD</span>
								</template>
								<template slot-scope="{ phasesInfo: { currentPhase } }">
									<template v-if="currentPhase == 0 || currentPhase == 1">
										<h2 class="pc-price inline text-white">${{ discountPrice | priceFormat }}</h2>
										<span class="holiday-price">${{ buildPrice | priceFormat }}</span>
									</template>
								</template>
							</promo-sales-timed>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div
			id="leave-warning"
			class="modal fade"
			tabindex="-1"
			role="dialog"
		>
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content">
					<div class="modal-header text-center">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h2 class="text-white">Leaving Configurator</h2>
					</div>
					<div class="modal-body text-white">
						<p>
							Going back will reset Configurator.
							<template v-if="!POS_MODE">Select 'save' or 'share' to continue with your selections later.</template>
						</p>
						<div class="text-center">
							<button class="big-submit" @click="leaveConfigurator()">Proceed</button>
							<button
								v-if="!POS_MODE"
								class="big-submit"
								data-toggle="modal"
								@click="saveBuild()"
							>
								Save
							</button>
							<button data-dismiss="modal" class="big-submit" @click="shareBuild('#share-overlay')">Share</button>
							<button data-dismiss="modal" class="big-submit">Cancel</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			id="leave-warning-step-1"
			class="modal fade"
			tabindex="-1"
			role="dialog"
		>
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content">
					<div class="modal-header text-center">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h2 class="text-white">Leaving Configurator</h2>
					</div>
					<div class="modal-body text-white">
						<p>
							Going back will reset Configurator.
							<template v-if="!POS_MODE">Select 'save' or 'share' to continue with your selections later.</template>
						</p>
						<div class="text-center">
							<button class="big-submit" @click="leaveConfigurator('step1')">Proceed</button>
							<button
								v-if="!POS_MODE"
								class="big-submit"
								data-toggle="modal"
								@click="saveBuild()"
							>
								Save
							</button>
							<button data-dismiss="modal" class="big-submit" @click="shareBuild('#share-overlay')">Share</button>
							<button data-dismiss="modal" class="big-submit">Cancel</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- /.nav-checkout -->
</template>

<script>
import { isMobile } from "../../../../../../util/helpers";
import { heapAnalytics } from "../../../../../../util/mixins";
import { mapActions, mapState } from "vuex";
import Affirm from "@c/generals/affirm";
import Paybright from "@c/generals/paybright";
import PromoSalesTimed from "@/components/promo-sales-timed";
import { promoDiscount } from "@u/helpers";


export default {
	name: "ConfigNavbar",
	components: {
		Affirm,
		Paybright,
		PromoSalesTimed
	},
	filters: {
		priceFormat(value) {
			value = value ? value : 0;
			value = parseFloat(value).toFixed(2);
			return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}
	},
	mixins: [heapAnalytics],
	data() {
		return {
			isOverviewOverlayOpen: false
		};
	},
	computed: {
		...mapState({
			buildPrice: state => state.Step4.buildPrice,
			countryCode: state => state.User.location.country_code,
			draftId: state => state.Step4.draftId,
			isCheckoutOverlayOpen: state => state.Step4.isCheckoutOverlayOpen,
			sessionData: state => state.Step4.sessionData
		}),
		discountPrice() {
			return promoDiscount(this.buildPrice);
		}

	},
	created() {
		EventBus.$on("save-build", () => {
			if (Cookies.get("cookies_id")) {
				this.shareBuild("#save-bld");
			}
		});
	},
	methods: {
		...mapActions([
			"changeShowLoadingOverlay",
			"changeDraftId",
			"changeLoadingText",
			"changeActiveTab"
		]),
		gotoStep5(pageLocation) {
			this.trackAll("Client: Click Checkout 2", { page_location: pageLocation });

			this.$router.push({
				name: "step5",
				query: {
					price: this.$route.query.price,
					draft: this.$route.query.draft
				}
			});
		},
		saveBuild() {
			$("#leave-warning").modal("hide");
			if (!Cookies.get("cookies_id")) {
				this.$modal.show("login-modal", { shouldSaveBuildOnClose: true });
			} else {
				this.shareBuild("#save-bld");
			}
		},
		shareBuild(elementId) {
			const bodyFormData = new FormData();
			bodyFormData.append("bld_number_draft", this.draftId);
			this.changeLoadingText("GENERATING");
			this.changeShowLoadingOverlay(true);
			axios({
				url: `/share?bld_number=${this.draftId}`,
				method: "POST",
				data: bodyFormData,
				headers: {
					token: CONFIG.SESSION
				}
			}).then(response => {
				const previousDraft = this.draftId;
				this.changeDraftId(response.data);
				axios({
					url: `/users/0/letsbld-drafts/${previousDraft}?session=${
						CONFIG.SESSION
					}`,
					method: "PUT",
					headers: {
						token: CONFIG.SESSION
					}
				}).then(() => {
					this.changeShowLoadingOverlay(false);
					$(elementId).modal("show");
				});
			});
		},
		leaveConfigurator(step) {
			this.startOverBld();

			if (isMobile()) {
				this.leaveConfiguratorMobile(step);
			} else {
				this.leaveConfiguratorDesktop(step);
			}
		},
		startOverBld() {
			this.changeActiveTab("case");
			window.localStorage.removeItem("session-price");
			window.localStorage.removeItem("session-draft");
			window.localStorage.removeItem("vuex-build");
			this.$store.dispatch("changeUserDraftId", null);
		},
		leaveConfiguratorDesktop(step) {
			if (step == "step1") {
				this.$router.push({
					name: "step1"
				});
			} else {
				let priceRange = 1000;

				// eslint-disable-next-line no-prototype-builtins
				if (window.localStorage.hasOwnProperty("session-price")) {
					priceRange = window.localStorage.getItem("session-price");
				} else if (this.$route.query.price) {
					priceRange = this.$route.query.price;
				}

				this.$router.push({
					path: `/bld/step3?price=${priceRange}&cpu=${
						this.sessionData.buildCpu
					}`
				});
			}
		},
		leaveConfiguratorMobile(step) {
			if (step == "step1") {
				this.$router.push({
					name: "step1"
				});
			} else {
				const cpuId =
					this.sessionData.cpu[0] &&
					this.sessionData.cpu[0].products_brands_id
						? this.sessionData.cpu[0].products_brands_id
						: "";
				const query = this.$route.query;
				if (cpuId && (cpuId == "2" || cpuId == "15")) {
					query.cpu = cpuId == "2" ? "intel" : "amd";
				}
				delete query.draft;
				this.$router.push({
					name: "step3",
					query
				});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.currency-code {
    font-size: 14px;
    font-weight: 200;
    color: rgba($color: #fafafa, $alpha: .6);
    margin-bottom: -10px;
    position: relative;
    margin-left: 2px;
}

.holiday-price {
    font-size: 19px;
    font-weight: 200;
    color: #fff;
    margin-bottom: -10px;
    position: relative;
    margin-left: 2px;
		text-decoration: line-through;
		bottom: -7px;
}

.checkout-btn.btn.btn-purple.inline {
    margin: 0 10px;
}

.affirm-step-4 {
    width: 250px;
}

.paybright-wrapper {
	border: 1px solid #525252;
	border-radius: 5px;
	padding: 3px 10px 4px;
	text-align: center;
	color: #c8c8c8;
	font-weight: 200;
	font-size: 12px;

    &:hover {
        background-color: #fff;
        color: #000;
    }
}
</style>
